<template>
  <div class="page">
    <div class="mainCard3">
      <div>
        <div style="display: flex;justify-content: space-between;margin-bottom: 15px;">
          <div>
            <el-button v-if="isOrgAdmin" type="primary" size="small" @click="openDepartmentDialog">新建部门</el-button>
            <el-button type="primary" size="small" @click="refreshDeptTree">刷新</el-button>
          </div>
          <div>
            <el-input
              placeholder="搜索部门"
              v-model="deptSearchKeyword"
              prefix-icon="el-icon-search"
              size="small"
              style="width: 200px;"
              @input="filterDeptTree"
            ></el-input>
          </div>
        </div>
        
        <!-- 部门树形结构 -->
        <el-tree
          ref="deptTree"
          :data="filteredDepartmentTree"
          :props="defaultProps"
          node-key="deptId"
          default-expand-all
          :expand-on-click-node="false"
          highlight-current
          @node-click="handleNodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
              <i class="el-icon-folder-opened" style="margin-right: 5px;"></i>
              {{ node.label }}
              <el-tag size="mini" type="info" v-if="data.hasUsers">有成员</el-tag>
            </span>
            <span>
              <el-button
                v-if="isOrgAdmin"
                type="text"
                size="mini"
                @click="() => addSubDepartment(data)">
                添加子部门
              </el-button>
              <el-button
                type="text"
                size="mini"
                @click="() => manageDepartmentMembers(data)">
                {{ isOrgAdmin ? '管理成员' : '查看成员' }}
              </el-button>
              <el-button
                v-if="isOrgAdmin"
                type="text"
                size="mini"
                @click="() => editDepartment(data)">
                编辑
              </el-button>
              <el-button
                v-if="isOrgAdmin"
                type="text"
                size="mini"
                @click="() => removeDepartment(node, data)">
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </div>

    <!-- 部门表单对话框 -->
    <el-dialog :title="departmentDialogType === 'add' ? '新建部门' : '编辑部门'" :visible.sync="departmentDialogVisible" width="40%">
      <el-form :model="departmentForm" :rules="departmentRules" ref="departmentForm" label-width="80px">
        <el-form-item label="部门名称" prop="deptName">
          <el-input v-model="departmentForm.deptName" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="上级部门">
          <el-select v-model="selectedParentDept" placeholder="请选择" style="width: 100%;">
            <el-option
              label="顶级部门"
              value="0">
            </el-option>
            <el-option
              v-for="item in departmentOptions"
              :key="item.deptId"
              :label="item.deptName"
              :value="item.deptId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="deptRemark">
          <el-input type="textarea" v-model="departmentForm.deptRemark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="departmentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitDepartment">确定</el-button>
      </div>
    </el-dialog>

    <!-- 部门成员对话框 -->
    <el-dialog 
      :title="selectedDept ? (isOrgAdmin ? '管理部门成员: ' : '查看部门成员: ') + selectedDept.deptName : '部门成员'" 
      :visible.sync="deptMembersDialogVisible" 
      width="60%"
    >
      <div>
        <el-button 
          v-if="isOrgAdmin" 
          type="primary" 
          size="small" 
          @click="addMemberToDept" 
          style="margin-bottom: 15px;">
          添加成员
        </el-button>
        
        <el-table 
          :data="deptMembers" 
          style="width: 100%" 
          v-loading="deptMembersLoading" 
          empty-text="该部门暂无成员"
        >
          <el-table-column prop="user.userName" label="姓名" width="120">
            <template slot-scope="scope">
              {{ scope.row.user && scope.row.user.userName ? scope.row.user.userName : '未知' }}
            </template>
          </el-table-column>
          <el-table-column prop="user.userPhone" label="手机号" width="120">
            <template slot-scope="scope">
              {{ scope.row.user && scope.row.user.userPhone ? scope.row.user.userPhone : '未知' }}
            </template>
          </el-table-column>
          <el-table-column prop="user.userEmail" label="邮箱">
            <template slot-scope="scope">
              {{ scope.row.user && scope.row.user.userEmail ? scope.row.user.userEmail : '未知' }}
            </template>
          </el-table-column>
          <el-table-column prop="user.userRemark" label="备注">
            <template slot-scope="scope">
              {{ scope.row.user && scope.row.user.userRemark ? scope.row.user.userRemark : '' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" v-if="isOrgAdmin">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                style="color: #F56C6C;"
                @click="removeMemberFromDept(scope.row)">
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deptMembersDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加部门成员对话框 -->
    <el-dialog 
      title="添加部门成员" 
      :visible.sync="addDeptMemberDialogVisible" 
      width="50%" 
      append-to-body
    >
      <div v-loading="loadingAvailableMembers">
        <el-table 
          :data="availableOrgMembers" 
          style="width: 100%" 
          empty-text="没有可添加的成员" 
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="user.userName" label="姓名" width="120">
            <template slot-scope="scope">
              {{ scope.row.user && scope.row.user.userName ? scope.row.user.userName : '未知' }}
            </template>
          </el-table-column>
          <el-table-column prop="user.userPhone" label="手机号" width="120">
            <template slot-scope="scope">
              {{ scope.row.user && scope.row.user.userPhone ? scope.row.user.userPhone : '未知' }}
            </template>
          </el-table-column>
          <el-table-column prop="user.userEmail" label="邮箱">
            <template slot-scope="scope">
              {{ scope.row.user && scope.row.user.userEmail ? scope.row.user.userEmail : '未知' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDeptMemberDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAddDeptMembers" :disabled="selectedOrgMembers.length === 0">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDepartmentTree,
  addDepartment,
  editDepartment,
  deleteDepartment,
  checkDepartmentHasUsers,
  getDepartmentMembers,
  addDepartmentMember,
  removeDepartmentMember,
  getAvailableOrgMembers
} from "@/api/userMG";

export default {
  name: "DeptManagement",
  data() {
    return {
      departmentDialogType: '',
      departmentForm: {
        deptName: '',
        deptRemark: ''
      },
      departmentTree: [],
      defaultProps: {
        children: 'children',
        label: 'deptName'
      },
      deptSearchKeyword: '',
      selectedDept: null,
      departmentDialogVisible: false,
      departmentOptions: [],
      selectedParentDept: '0',
      departmentRules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      deptMembersDialogVisible: false,
      deptMembers: [],
      deptMembersLoading: false,
      addDeptMemberDialogVisible: false,
      loadingAvailableMembers: false,
      deptMemberForm: {
        deptId: '',
        userId: ''
      },
      selectedOrgMembers: [],
      availableOrgMembers: [],
      
      // 当前用户和组织信息
      user: {},
      company: {}
    };
  },
  created() {
    try {
      // 从localStorage获取用户和公司信息
      this.user = JSON.parse(localStorage.getItem('userdata') || '{}');
      this.company = JSON.parse(localStorage.getItem('company') || '{}');
      if(!this.company) return ;

      console.log('架构管理组件初始化 - 当前用户:', this.user.userId, '当前组织:', this.company.companyId);
      
      // 初始化加载部门树
      this.getDeptTree();
    } catch (error) {
      console.error('架构管理组件初始化失败:', error);
      this.$message.error('组件初始化失败，请刷新页面重试');
    }
  },
  computed: {
    isOrgAdmin() {
      // 判断当前用户是否为组织管理员
      return this.company && this.user && this.company.userId === this.user.userId;
    },
    filteredDepartmentTree() {
      if (!this.deptSearchKeyword) {
        return this.departmentTree;
      }
      
      const keyword = this.deptSearchKeyword.toLowerCase();
      
      // 递归筛选部门树
      const filterNodes = (nodes) => {
        return nodes.filter(node => {
          // 检查当前节点是否匹配关键字
          const isMatch = node.deptName.toLowerCase().includes(keyword);
          
          // 如果有子节点，递归筛选
          if (node.children && node.children.length) {
            const matchingChildren = filterNodes(node.children);
            
            // 更新子节点
            if (matchingChildren.length) {
              node.children = matchingChildren;
              return true; // 如果有匹配的子节点，也保留父节点
            }
          }
          
          return isMatch; // 如果当前节点匹配，则保留
        });
      };
      
      return filterNodes([...this.departmentTree]);
    }
  },
  methods: {
    getDeptTree() {
      if (!this.company || !this.company.companyId) {
        this.$message.error('无法获取组织信息');
        return;
      }
      
      getDepartmentTree(this.company.companyId).then(res => {
        if (res.code === 200) {
          this.departmentTree = res.data || [];
          this.buildDepartmentOptions();
        } else {
          this.$message.error(res.msg || '获取部门树失败');
        }
      }).catch(err => {
        console.error('获取部门树失败', err);
        this.$message.error('获取部门树失败');
      });
    },
    
    refreshDeptTree() {
      this.getDeptTree();
      this.$message.success('刷新成功');
    },
    
    filterDeptTree() {
      // filteredDepartmentTree计算属性已经处理了过滤逻辑
    },
    
    handleNodeClick(data) {
      console.log(data);
      this.selectedDept = data;
    },
    
    openDepartmentDialog(type = 'add') {
      if (type === 'add' && !this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      this.departmentDialogType = 'add';
      this.departmentForm = {
        deptName: '',
        deptRemark: '',
        companyId: this.company.companyId,
        deptParent: '0'
      };
      this.selectedParentDept = '0';
      this.departmentDialogVisible = true;
      this.buildDepartmentOptions();
    },
    
    buildDepartmentOptions() {
      // 递归将部门树转为平级结构，用于选择上级部门
      const flattenDepts = (depts, level = 0, parentPath = '') => {
        let result = [];
        depts.forEach(dept => {
          const path = parentPath ? `${parentPath} / ${dept.deptName}` : dept.deptName;
          result.push({
            deptId: dept.deptId,
            deptName: '　'.repeat(level) + dept.deptName + (level > 0 ? ` (${path})` : '')
          });
          if (dept.children && dept.children.length) {
            result = result.concat(flattenDepts(dept.children, level + 1, path));
          }
        });
        return result;
      };
      
      this.departmentOptions = flattenDepts(this.departmentTree);
    },
    
    submitDepartment() {
      this.$refs.departmentForm.validate(valid => {
        if (!valid) {
          return false;
        }
        
        // 设置上级部门ID
        this.departmentForm.deptParent = this.selectedParentDept;
        
        // 根据对话框类型调用不同的API
        const submitMethod = this.departmentDialogType === 'edit' ? editDepartment : addDepartment;
        const successMsg = this.departmentDialogType === 'edit' ? '编辑部门成功' : '新增部门成功';
        
        submitMethod(this.departmentForm).then(res => {
          if (res.code === 200) {
            this.$message.success(successMsg);
            this.departmentDialogVisible = false;
            this.getDeptTree(); // 刷新部门树
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        }).catch(err => {
          console.error('操作失败', err);
          this.$message.error('操作失败');
        });
      });
    },
    
    addSubDepartment(data) {
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      this.departmentDialogType = 'add';
      this.departmentForm = {
        deptName: '',
        deptRemark: '',
        companyId: this.company.companyId,
        deptParent: data.deptId // 设置父部门ID
      };
      this.selectedParentDept = data.deptId;
      this.departmentDialogVisible = true;
      this.buildDepartmentOptions();
    },
    
    editDepartment(data) {
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      this.departmentDialogType = 'edit';
      this.departmentForm = {
        deptId: data.deptId,
        deptName: data.deptName,
        deptRemark: data.deptRemark || '',
        companyId: data.companyId,
        deptParent: data.deptParent
      };
      this.selectedParentDept = data.deptParent;
      this.departmentDialogVisible = true;
      this.buildDepartmentOptions();
    },
    
    removeDepartment(node, data) {
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      // 先检查是否有子部门
      if (data.children && data.children.length > 0) {
        this.$message.warning('该部门下有子部门，不能删除，请先删除子部门');
        return;
      }
      
      // 再检查是否有用户
      checkDepartmentHasUsers(data.deptId).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.$message.warning('该部门下有成员，不能删除，请先移除成员');
            return;
          }
          
          // 确认删除
          this.$confirm('确认删除该部门?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            deleteDepartment(data.deptId).then(res => {
              if (res.code === 200) {
                this.$message.success('删除成功');
                this.getDeptTree(); // 刷新部门树
              } else {
                this.$message.error(res.msg || '删除失败');
              }
            }).catch(err => {
              console.error('删除失败', err);
              this.$message.error('删除失败');
            });
          }).catch(() => {
            this.$message.info('已取消删除');
          });
        } else {
          this.$message.error(res.msg || '检查部门成员失败');
        }
      }).catch(err => {
        console.error('检查部门成员失败', err);
        this.$message.error('检查部门成员失败');
      });
    },
    
    getParentDeptName(parentId) {
      if (parentId === '0') {
        return '顶级部门';
      }
      
      // 平铺部门树，找到父部门名称
      const flattenDepts = (depts) => {
        let result = [];
        depts.forEach(dept => {
          result.push(dept);
          if (dept.children && dept.children.length) {
            result = result.concat(flattenDepts(dept.children));
          }
        });
        return result;
      };
      
      const allDepts = flattenDepts(this.departmentTree);
      const parentDept = allDepts.find(dept => dept.deptId === parentId);
      
      return parentDept ? parentDept.deptName : '未知部门';
    },
    
    manageDepartmentMembers(data) {
      this.selectedDept = data;
      this.deptMembersDialogVisible = true;
      this.loadDeptMembers(data.deptId);
    },
    
    loadDeptMembers(deptId) {
      this.deptMembersLoading = true;
      
      getDepartmentMembers(deptId).then(res => {
        if (res.code === 200) {
          this.deptMembers = res.rows || [];
          // 确保每个成员都有user属性
          this.deptMembers.forEach(member => {
            if (!member.user) {
              member.user = {}; // 创建空user对象避免前端报错
            }
          });
        } else {
          this.$message.error(res.msg || '获取部门成员失败');
        }
        this.deptMembersLoading = false;
      }).catch(err => {
        console.error('获取部门成员失败', err);
        this.$message.error('获取部门成员失败');
        this.deptMembersLoading = false;
      });
    },
    
    addMemberToDept() {
      // 检查是否有管理员权限
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      // 加载可用的组织成员
      this.loadAvailableOrgMembers();
      this.addDeptMemberDialogVisible = true;
    },
    
    loadAvailableOrgMembers() {
      if (!this.company || !this.company.companyId || !this.selectedDept || !this.selectedDept.deptId) {
        this.$message.error('缺少必要参数');
        return;
      }
      
      this.loadingAvailableMembers = true;
      getAvailableOrgMembers(this.company.companyId, this.selectedDept.deptId).then(res => {
        if (res.code === 200) {
          this.availableOrgMembers = res.data || [];
          // 确保每个成员都有user属性
          this.availableOrgMembers.forEach(member => {
            if (!member.user) {
              member.user = {}; // 创建空user对象避免前端报错
            }
          });
          console.log('成功加载可用组织成员', this.availableOrgMembers.length + '个成员');
        } else {
          console.error('获取可用成员返回异常', res);
          this.$message.error(res.msg || '获取可用成员失败');
        }
        this.loadingAvailableMembers = false;
      }).catch(err => {
        console.error('获取可用成员失败', err);
        this.$message.error('获取可用成员失败: ' + (err.message || JSON.stringify(err)));
        this.loadingAvailableMembers = false;
      });
    },
    
    handleSelectionChange(val) {
      this.selectedOrgMembers = val;
    },
    
    submitAddDeptMembers() {
      if (this.selectedOrgMembers.length === 0) {
        this.$message.warning('请选择要添加的成员');
        return;
      }
      
      if (!this.selectedDept || !this.selectedDept.deptId) {
        this.$message.error('部门信息不完整');
        return;
      }
      
      const promises = this.selectedOrgMembers.map(member => {
        if (!member || !member.userId) {
          console.warn('成员信息不完整', member);
          return Promise.resolve(); // 跳过无效成员
        }
        
        const params = {
          userId: member.userId,
          deptId: this.selectedDept.deptId
        };
        return addDepartmentMember(params);
      });
      
      Promise.all(promises).then(() => {
        this.$message.success('添加成功');
        this.addDeptMemberDialogVisible = false;
        this.loadDeptMembers(this.selectedDept.deptId);
      }).catch(err => {
        console.error('添加成员失败', err);
        this.$message.error('添加成员失败');
      });
    },
    
    removeMemberFromDept(row) {
      // 检查是否有管理员权限
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      this.$confirm('确认要从该部门移除该成员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeDepartmentMember(row.id).then(() => {
          this.$message.success('移除成功');
          this.loadDeptMembers(this.selectedDept.deptId);
        }).catch(err => {
          console.error('移除成员失败', err);
          this.$message.error('移除成员失败');
        });
      }).catch(() => {
        this.$message.info('已取消');
      });
    }
  }
};
</script>

<style scoped>
.page {
  width: 100%;
  color: #000000;
}

.mainCard3 {
  width: 100%;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  height: auto;
  /* 移除固定高度限制 */
}

.mainCard3 >>> .el-table__cell {
  border: 0px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
:global{
  .el-tree__empty-block{
    height: auto !important;
  }
}
</style> 


// WEBPACK FOOTER //
// src/views/auth/deptManagement.vue